export var PlaygroundMode;
(function (PlaygroundMode) {
    PlaygroundMode["EDITOR"] = "EDITOR";
    PlaygroundMode["PREVIEW"] = "PREVIEW";
})(PlaygroundMode || (PlaygroundMode = {}));
//# sourceMappingURL=mode.enum.js.map